<template>
  <div>
    <md-table v-model="users.data" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Referencia">{{ item.id }}</md-table-cell>
        <md-table-cell md-label="Comentario">{{
          item.comentario
        }}</md-table-cell>
        <md-table-cell md-label="Fecha y Hora"
          >{{ item.fecha_pago }} {{ item.hora_pago }}</md-table-cell
        >
        <md-table-cell md-label="Metodo">{{ item.metodo }}</md-table-cell>
        <md-table-cell md-label="Tipo">{{ item.tipo }}</md-table-cell>
        <md-table-cell md-label="">
          <p style="color:green;" v-if="item.tipo == 'ingreso'">
            <md-icon style="color:green;">add</md-icon> {{ item.pago }}
          </p>
          <p style="color:red;" v-if="item.tipo == 'egreso'">
            <md-icon style="color:red;">remove</md-icon> {{ item.pago }}
          </p>
        </md-table-cell>
        <md-table-cell
          md-label=""
        >
          <a v-if="item.metodo == 'tarjeta' && item.comprobado == 'no'" v-on:click="Comprobar(item)"
            ><md-icon style="color:blue;">save_alt</md-icon
            ><md-tooltip md-direction="top">Confirmar pago</md-tooltip></a
          >

          <a
            v-on:click="Delete(item.id)"
            ><md-icon style="color: red">delete_forever</md-icon
            ><md-tooltip md-direction="top">Eliminar</md-tooltip></a
          >
        </md-table-cell>
      </md-table-row>
    </md-table>
    <hr />
    <md-table>
      <md-table-row>
        <md-button class="md-warning" v-on:click="Anterior()"
          >Anterior</md-button
        >
        <md-button class="md-warning" disabled
          >{{ page }} de {{ pages }}</md-button
        >
        <md-button class="md-warning" v-on:click="Siguiente()"
          >Siguiente</md-button
        >
      </md-table-row>
    </md-table>

    <md-card
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      style="margin: 20px"
    >
      <md-card-content>
        <md-radio v-model="radio" v-on:change="SetComprobar()" value="si"
          >Comprobados</md-radio
        >
        <md-radio v-model="radio" v-on:change="SetComprobar()" value="no"
          >Por Comprobar</md-radio
        >
        <md-radio v-model="metodo" v-on:change="SetMetodo()" value="todos"
          >Todos</md-radio
        >
        <md-radio v-model="metodo" v-on:change="SetMetodo()" value="efectivo"
          >Efectivo</md-radio
        >
        <md-radio v-model="metodo" v-on:change="SetMetodo()" value="tarjeta"
          >Tarjeta</md-radio
        >
        <md-datepicker v-model="fecha">
          <label>Filtrar por fecha</label>
        </md-datepicker>
        <md-button class="md-button" v-on:click="SetFecha()">
          <md-icon>event_available</md-icon>
        </md-button>

        <md-button class="md-button md-primary" v-on:click="Reset()">
          <md-icon>cached</md-icon>
        </md-button>

        <md-dialog :md-active.sync="showDialog">
          <md-tab md-label="General">
            <form novalidate v-on:submit.prevent="Save()" class="md-layout">
              <md-card class="md-layout-item md-size-100 md-small-size-100">
                <md-card-header :data-background-color="'blue'">
                  <b>Nuevo Movimiento</b>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-field maxlength="3">
                        <label>Numero de factura</label>
                        <md-input
                          v-model="num_factura"
                          type="number"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field maxlength="3">
                        <label>Movimiento</label>
                        <md-textarea
                          v-model="movivmiento"
                          required
                        ></md-textarea>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Metodo de pago</label>
                        <md-select
                          v-model="nuevometodo"
                          name="metodo"
                          id="metodo"
                          required
                        >
                          <md-option value="efectivo">Efectivo</md-option>
                          <md-option value="tarjeta">Tarjeta</md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Tipo</label>
                        <md-select
                          v-model="tipo"
                          name="tipo"
                          id="tipo"
                          required
                        >
                          <md-option value="ingreso">Ingreso</md-option>
                          <md-option value="egreso">Egreso</md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <md-field>
                        <label>Monto</label>
                        <md-input
                          v-model="monto"
                          type="number"
                          step="0.01"
                          min="0.00"
                          required
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100 text-right">
                      <md-button
                        class="md-secondary"
                        @click="showDialog = false"
                        >Cancelar</md-button
                      >
                      <md-button
                        type="submit"
                        class="md-raised md-info"
                        style="margin-left: 5px"
                        >Agregar</md-button
                      >
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </form>
          </md-tab>
        </md-dialog>

        <md-button class="md-info md-raised" @click="showDialog = true"
          ><md-icon>add_shopping_cart</md-icon> Nuevo Movimiento</md-button
        >
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import Global from "../../Global";

export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      users: [],
      page: 1,
      pages: null,
      url: Global.url,
      radio: "si",
      metodo: "todos",
      fecha: null,
      showDialog: false,
      monto: null,
      nuevometodo: null,
      movivmiento: null,
      num_factura: null,
      tipo: null
    };
  },
  mounted() {
    this.getPedidos(this.radio, this.metodo, this.fecha);
  },
  methods: {
    getPedidos(comp, met, fecha) {
      if (fecha == null) {
        axios
          .get(
            this.url +
              "caja/" +
              comp +
              "/" +
              met +
              "?page=" +
              this.page +
              "&api_token=" +
              localStorage.usertoken
          )
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
          });
      } else {
        axios
          .get(
            this.url +
              "caja/" +
              comp +
              "/" +
              met +
              "/" +
              this.$moment(this.fecha).format("Y-MM-DD") +
              "?page=" +
              this.page +
              "&api_token=" +
              localStorage.usertoken
          )
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
          });
      }
    },
    Siguiente() {
      if (this.page + 1 <= this.pages) {
        axios
          .get(
            this.users.next_page_url + "&api_token=" + localStorage.usertoken
          )
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    Anterior() {
      if (this.page - 1 > 0) {
        axios
          .get(
            this.users.prev_page_url + "&api_token=" + localStorage.usertoken
          )
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    SetComprobar() {
      this.getPedidos(this.radio, this.metodo, this.fecha);
    },
    SetMetodo() {
      this.getPedidos(this.radio, this.metodo, this.fecha);
    },
    SetFecha() {
      this.getPedidos(this.radio, this.metodo, this.fecha);
    },
    Delete(id) {
      if (confirm("Seguro quieres eliminar movimiento N° " + id)) {
        axios
          .delete(this.url + "caja/" + id, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(response => {
            if (response.status == 200) {
              this.getPedidos(this.radio, this.metodo, this.fecha);
            }
          });
      }
    },
    Reset() {
      this.radio = "si";
      this.metodo = "todos";
      this.fecha = null;

      this.getPedidos(this.radio, this.metodo, this.fecha);
    },
    Comprobar(item) {
      if (confirm("Seguro quieres confirmar el pago: " + item.comentario)) {
        axios
          .get(this.url + "caja/comprobar/" + item.id, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.getPedidos(this.radio, this.metodo, this.fecha);
          });
      }
    },
    Save() {
      axios
        .post(
          this.url + "caja",
          {
            comentario: this.movivmiento,
            num_factura: this.num_factura,
            monto: this.monto,
            metodo: this.nuevometodo,
            tipo: this.tipo
          },
          {
            headers: { ApiToken: localStorage.usertoken }
          }
        )
        .then(res => {
          this.movivmiento = null;
          this.num_factura = null;
          this.monto = null;
          this.nuevometodo = null;
          this.tipo = null;
          this.showDialog = false;
          this.getPedidos(this.radio, this.metodo, this.fecha);
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
